export default "__VITE_ASSET__BL1647Vv__"